import classNames from 'classnames/bind';
import styles from './FaqCategories.module.scss';
import { Heading, List } from '@/components';
import Link from 'next/link';
let cx = classNames.bind(styles);

export function FaqCategories({ title, categories, basePath }) {
	return (
		<>
			<Heading level="h3" className={cx(['is-style-heading-eyebrow'])}>
				{title}
			</Heading>

			<List elem="ul" listStyle="none" className={cx(['faqs-category-list'])}>
				{categories.map((category) => (
					<li key={category.id}>
						<Link href={`${basePath}/${category.id}`}>{category.name}</Link>
					</li>
				))}
			</List>
		</>
	);
}
